import { Sort } from '@angular/material/sort';

export enum EHokStatus {
    Active = 'Active',
    Off = 'Off',
    Canceled = 'Canceled',
    Transference = 'Transference',
    All = 'All'
}

export interface IFilterUsers {
    name: string;
    id: string;
}
export interface IFilterCard {
    activeStatus: number;
    shortCardNumber: string;
    cardIndex: number;
    userIndex: number;
    cardName: string;
    cardImage: string;
}

export interface IFilterBank {
    accountNumber: number;
    bankID: number;
    bankName: string;
    branchID: number;
    cards: IFilterCard[];
    bankAccountIndex: number;
}
// tslint:disable-next-line:no-empty-interface
export interface ISortedState extends Sort {}
export interface IFilterState {
    selectedUser: IFilterUsers;
    selectedCard: IFilterCard[];
    selectedStatus: EHokStatus;
    selectedSort: ISortedState;
    bankAccount?: IFilterBank;
}
